import React from 'react';
import './styles.css';
import { useAuth } from '@BUP/hooks';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

export const UserProfile = () => {
  const { user, emailPasswordReset } = useAuth();
  const [t] = useTranslation();

  const onPasswordReset = async () => {
    try {
      const { email } = user;
      // console.log('PasswordResetPage submit', email);
      await emailPasswordReset(email);
    } catch (e) {
      // console.log('PasswordResetPage error', e);
    }
  };

  return (
    <div className="profile-page">
      <div className="profile-user-information">
        <ul>
          <li>
            <strong>{t('pages.profile.name')}:</strong> {user?.name || ' '}.
          </li>
          <li>
            <strong>{t('pages.profile.email')}:</strong> {user?.email || ' '}.
          </li>
          <li>
            <strong>{t('pages.profile.school')}:</strong>{' '}
            {user?.organizations?.name || ' '}.
          </li>
          <li>
            <strong>{t('pages.profile.role')}:</strong>{' '}
            {user?.roles?.name || ' '}.
          </li>

          <li>
            <strong>{t('pages.profile.course')}:</strong>{' '}
            {user?.courses?.name || '-'}.
          </li>
        </ul>
        <Button shape="round" type="primary" onClick={() => onPasswordReset()}>
          {t('pages.profile.buttonTextPassword')}
        </Button>
      </div>

      {/* <div className="profile-footer">
        <p>
          Si eres parte de otro estamento de la comunidad o tus datos son
          erroneos acercate a hablar con el equipo de convivencia para que te
          ayudemos a editar tu perfil.
        </p>
      </div> */}
    </div>
  );
};
